import React from 'react';

import { ReactComponent as SpinnerIcon } from 'svg/spinner.svg';
import { createClassName } from 'utils/createClassName';

import './spinnerStyles.scss';

type TProps = {
  className?: string;
  testId?: string;
};

export const SpinnerComponent = (props: TProps) => {
  const { testId } = props;

  const className = createClassName('spinner')();

  return <SpinnerIcon className={className} data-testid={testId} />;
};
